// Sticky nav
const nav = document.getElementById('site-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  });
}

// Product filter buttons
document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    // Featured DSG has its own exact per-card category filter.
    // Do not let this legacy global handler override it.
    if (this.closest('[data-jjl-exact-filter]')) return;
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    this.classList.add('active');
    const filter = this.dataset.filter;
    document.querySelectorAll('.product-card').forEach(card => {
      const tags = (card.dataset.category || '').split(',');
      if (filter === 'all' || tags.indexOf(filter) !== -1) {
        card.style.display = 'block';
      } else {
        card.style.display = 'none';
      }
    });
  });
});

// Add to cart (Shopify AJAX)
document.querySelectorAll('.btn-add-to-cart').forEach(btn => {
  btn.addEventListener('click', async function (e) {
    e.preventDefault();
    e.stopPropagation();
    const variantId = this.dataset.variantId;
    if (!variantId) return;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        const original = this.textContent;
        this.textContent = 'Added ✓';
        setTimeout(() => this.textContent = original, 2000);
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const counter = document.querySelector('.cart-count');
        if (counter) counter.textContent = cart.item_count;
      } else {
        const errData = await res.json();
        console.error('Add to cart failed:', errData);
      }
    } catch (err) {
      console.error('Add to cart error:', err);
    }
  });
});

// Product page: thumbnail gallery swap
document.querySelectorAll('.product-page__thumb').forEach(thumb => {
  thumb.addEventListener('click', function () {
    const full = this.dataset.full;
    const mainImg = document.getElementById('ProductMainImage');
    if (mainImg && full) {
      mainImg.src = full;
    }
    document.querySelectorAll('.product-page__thumb').forEach(t => t.classList.remove('active'));
    this.classList.add('active');
  });
});

// Cart page: quantity field updates trigger form auto-submit on change
document.querySelectorAll('.cart-table__qty').forEach(input => {
  input.addEventListener('change', function () {
    const form = this.closest('form');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });
});

// Product recommendations: fetch via Shopify's recommendations endpoint
const recoSection = document.getElementById('ProductRecommendations');
if (recoSection) {
  const url = recoSection.dataset.url;
  fetch(url)
    .then(res => res.text())
    .then(html => {
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const grid = temp.querySelector('#ProductRecommendationsGrid');
      const target = document.getElementById('ProductRecommendationsGrid');
      if (grid && target && grid.innerHTML.trim()) {
        target.innerHTML = grid.innerHTML;
      } else if (target && !target.innerHTML.trim()) {
        recoSection.style.display = 'none';
      }
    })
    .catch(() => { recoSection.style.display = 'none'; });
}

// Variant price update
(function () {
  const productDataEl = document.querySelector('[data-product-json]');
  if (!productDataEl) return;

  const product = JSON.parse(productDataEl.textContent);

  function updatePrice(variant) {
    if (!variant) return;
    const formatted = (variant.price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });

    // Update main price display
    const priceEl = document.querySelector('.product-page__price');
    if (priceEl) {
      if (variant.compare_at_price > variant.price) {
        priceEl.innerHTML = `<s>${(variant.compare_at_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</s> ${formatted}`;
      } else {
        priceEl.textContent = formatted;
      }
    }

    // Update price in Add to Cart button
    const moneyEl = document.querySelector('.money-js');
    if (moneyEl) moneyEl.textContent = formatted;

    // Update hidden variant ID input
    const variantInput = document.getElementById('ProductSelectedVariant');
    if (variantInput) variantInput.value = variant.id;
  }

  document.querySelectorAll('select[name^="options"]').forEach(el => {
    el.addEventListener('change', function () {
      const selectedOptions = Array.from(
        document.querySelectorAll('select[name^="options"]')
      ).map(s => s.value);

      const variant = product.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
      updatePrice(variant);
    });
  });
})();

document.addEventListener('DOMContentLoaded', function () {

  const notifyButton = document.querySelector('.product-page__add');

  if (notifyButton) {
    notifyButton.addEventListener('click', function () {

      if (window._klOnsite) {
        window._klOnsite.push(['openForm', 'XzvTxR']);
      } else {
        console.log('Klaviyo is not loaded.');
      }

    });
  }

});

// PDP mobile gallery: swipe navigation + clean controls beneath the image.
document.addEventListener('DOMContentLoaded', function () {
  const mainImage = document.getElementById('ProductMainImage');
  const mainFrame = document.querySelector('.product-page__main-image');
  const thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));

  if (!mainImage || !mainFrame || thumbs.length < 2) return;
  if (document.querySelector('.jjl-pdp-mobile-controls')) return;

  if (!document.getElementById('jjl-pdp-mobile-gallery-style')) {
    const style = document.createElement('style');
    style.id = 'jjl-pdp-mobile-gallery-style';
    style.textContent = `
      .jjl-pdp-mobile-controls { display: none; }

      @media (max-width: 749px) {
        .product-page__main-image {
          touch-action: pan-y !important;
        }

        .product-page__main-image .product-page__gallery-arrow {
          display: none !important;
        }

        .jjl-pdp-mobile-controls {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1rem;
          margin: .72rem 0 .25rem;
          padding: 0 .5rem;
        }

        .jjl-pdp-mobile-control {
          width: 2.3rem;
          height: 2.3rem;
          display: grid;
          place-items: center;
          border: 1px solid rgba(43, 29, 20, .22);
          border-radius: 999px;
          background: var(--ivory, #FAF6EE);
          color: var(--espresso, #2b1d14);
          font-size: 1rem;
          line-height: 1;
          cursor: pointer;
        }

        .jjl-pdp-mobile-control:focus-visible {
          outline: 2px solid #c9a44c;
          outline-offset: 2px;
        }

        .jjl-pdp-mobile-counter {
          min-width: 3.9rem;
          text-align: center;
          font-family: 'Jost', sans-serif;
          font-size: .68rem;
          letter-spacing: .12em;
          color: var(--espresso, #2b1d14);
          opacity: .66;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const controls = document.createElement('div');
  controls.className = 'jjl-pdp-mobile-controls';
  controls.setAttribute('aria-label', 'Product gallery controls');
  controls.innerHTML =
    '<button type="button" class="jjl-pdp-mobile-control" data-jjl-mobile-prev aria-label="Previous product image">&#8592;</button>' +
    '<span class="jjl-pdp-mobile-counter" data-jjl-gallery-counter aria-live="polite"></span>' +
    '<button type="button" class="jjl-pdp-mobile-control" data-jjl-mobile-next aria-label="Next product image">&#8594;</button>';
  mainFrame.insertAdjacentElement('afterend', controls);

  const counter = controls.querySelector('[data-jjl-gallery-counter]');
  let index = thumbs.findIndex(thumb => thumb.classList.contains('active'));
  if (index < 0) index = 0;

  function syncCounter(nextIndex) {
    index = (nextIndex + thumbs.length) % thumbs.length;
    counter.textContent = `${index + 1} / ${thumbs.length}`;
  }

  function show(nextIndex) {
    const target = (nextIndex + thumbs.length) % thumbs.length;
    thumbs[target].click();
    syncCounter(target);
  }

  thumbs.forEach((thumb, thumbIndex) => {
    thumb.addEventListener('click', function () {
      syncCounter(thumbIndex);
    });
  });

  controls.querySelector('[data-jjl-mobile-prev]').addEventListener('click', function () {
    show(index - 1);
  });
  controls.querySelector('[data-jjl-mobile-next]').addEventListener('click', function () {
    show(index + 1);
  });
  syncCounter(index);

  let startX = 0;
  let startY = 0;
  let suppressNextClick = false;

  mainImage.addEventListener('touchstart', function (event) {
    const touch = event.touches && event.touches[0];
    if (!touch) return;
    startX = touch.clientX;
    startY = touch.clientY;
  }, { passive: true });

  mainImage.addEventListener('touchend', function (event) {
    const touch = event.changedTouches && event.changedTouches[0];
    if (!touch) return;

    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;

    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.15) {
      event.preventDefault();
      suppressNextClick = true;
      show(index + (dx < 0 ? 1 : -1));
      window.setTimeout(function () {
        suppressNextClick = false;
      }, 450);
    }
  }, { passive: false });

  mainImage.addEventListener('click', function (event) {
    if (!suppressNextClick) return;
    suppressNextClick = false;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
});
